/**
 * AboutDialog — the profile menu's "About".
 *
 * Port of legacy components/HeaderModals/aboutModal.vue: a small dialog with
 * the product's title and text, closed by ✕ (or Esc / a click outside), no
 * footer, no version. Text verbatim per product; the one change is the
 * opening quote of “Meta Collector”, straight in legacy against a curly
 * closing one.
 */
import { Modal } from '@components/ui';
import { useAppMode } from '@variant/useAppMode';
import { VariantGate } from '@variant/VariantGate';

import styles from './AboutDialog.module.css';

/** Legacy's headings, per product (aboutModal.vue). */
export const ABOUT_TITLES = Object.freeze({
  cca: 'About Cloud Cost Advisor',
  eia: 'About Enterprise Instance Advisory',
});

export function AboutDialog({ onClose }) {
  const { mode } = useAppMode();

  // The library Modal's own width (460px) stands in for legacy's 500px.
  return (
    <Modal open onClose={onClose} title={ABOUT_TITLES[mode]}>
      <div className={styles.body}>
        <VariantGate only="cca">
          <p>
            Get real-time insights into estimated cost savings when switching to cloud instances
            powered by AMD within the same Cloud Service Provider(CSP).
          </p>
        </VariantGate>
        <VariantGate only="eia">
          <p>
            Enterprise Instance Advisory is a powerful recommendation engine designed to analyze
            historical system statistics and generate tailored cloud instance recommendations.
          </p>
          <p>
            To get started, download the MetaCollector package by clicking the{' '}
            <strong>“Meta Collector”</strong> button. This will redirect you to the MetaCollector
            page, where you can download the executable package for both Windows and Linux
            platforms. The MetaCollector tool captures essential system statistics such as CPU,
            memory, network, and I/O utilization. For detailed setup and usage instructions, refer
            to the “MetaCollector User guide”. Click <strong>User Guide</strong> on the
            MetaCollector page to download the user guide in PDF format.
          </p>
          <p>
            Once you&apos;ve collected the system statistics using Meta Collector, upload the
            generated output files to the EIA portal to receive tailored instance recommendations.
            You may upload a single .xlsx file containing statistics for multiple systems or use the
            downloadable excel template to input the required details manually.
          </p>
        </VariantGate>
      </div>
    </Modal>
  );
}

export default AboutDialog;
